import { render, staticRenderFns } from "./ActivityManagement.vue?vue&type=template&id=45faeac8&scoped=true&"
import script from "./ActivityManagement.vue?vue&type=script&lang=js&"
export * from "./ActivityManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45faeac8",
  null
  
)

export default component.exports